module.exports = __webpack_public_path__ + "41d73a02f1de78d0ad58cffb0e6e5dec.svg";